<template> 
   <div class="cn_title">
        <Button class="mR15" type="info">添加</Button>
        <Button type="warning">批量操作</Button>

        <ul>
            <li>
               {{search}} 
            </li>
        </ul>
   </div>
</template> 
<script>
    export default {
        data () {
            return {
             
            }
        },  
        props: ['search'], 
        computed: {
        
        },
        methods: {
            load(){
                let that = this;
                let data1 = `?`;
                
                that.$myAjax.get('admin/service/admin/news/select'+data1).then( res => {
                    console.log(res.data.data)
                })
            }
        },
        mounted: function(){
            var that = this;
            that.load();
            
        }
    }
</script>  
<style scoped>
    
</style>
     